import { keyBy } from 'lodash'

import {
  FETCH_VENUE_SETTINGS_REQUESTED,
  FETCH_VENUE_SETTINGS_SUCCEEDED,
  FETCH_VENUE_SETTINGS_FAILED,
  CREATE_VENUE_SETTINGS_REQUESTED,
  CREATE_VENUE_SETTINGS_SUCCEEDED,
  CREATE_VENUE_SETTINGS_FAILED,
  CREATE_VENUE_SETTINGS_NEW_REQUESTED,
  CREATE_VENUE_SETTINGS_NEW_SUCCEEDED,
  CREATE_VENUE_SETTINGS_NEW_FAILED,
  FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_REQUESTED,
  FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_SUCCEEDED,
  FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_FAILED,
  FETCH_SETTINGS_FOR_STANDS_REQUESTED,
  FETCH_SETTINGS_FOR_STANDS_SUCCEEDED,
  FETCH_SETTINGS_FOR_STANDS_FAILED,
} from './constants'
import { revenueCentersUtils } from 'components/RevenueCenters/utils'
import settingsUtils from 'utils/settings'

const initialState = {
  standsSettings: {
    settings: {
      byId: {},
    },
    defaultSettings: {
      byName: {},
    },
  },
  venueSettings: {
    settings: {
      byId: {},
    },
    defaultSettings: {
      byName: {},
    },
  },
  byName: {},
  isLoading: false,
}

const state = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_SUCCEEDED: {
      const settingsNames = settingsUtils.getAllVenueSettingsNames()

      const venueSettings = payload?.settings?.filter(
        (venueSetting) => settingsNames.includes(venueSetting.name)
      )

      const venueDefaultSettings = payload?.defaultSettings?.filter(
        (defaultSetting) =>
          settingsNames.includes(defaultSetting.name)
      )

      return {
        ...state,
        isLoading: false,
        venueSettings: {
          settings: {
            byId: keyBy(venueSettings, 'uuid'),
          },
          defaultSettings: {
            byName: keyBy(venueDefaultSettings, 'name'),
          },
        },
      }
    }

    case FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case FETCH_SETTINGS_FOR_STANDS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_SETTINGS_FOR_STANDS_SUCCEEDED: {
      const settingsNames =
        revenueCentersUtils.getAllStandsSettingsNames()

      const standsSettings = payload?.settings?.filter((setting) =>
        settingsNames.includes(setting.name)
      )

      const standsDefaultSettings = payload?.defaultSettings?.filter(
        (defaultSetting) =>
          settingsNames.includes(defaultSetting.name)
      )

      return {
        ...state,
        isLoading: false,
        standsSettings: {
          settings: {
            byId: keyBy(standsSettings, 'uuid'),
          },
          defaultSettings: {
            byName: keyBy(standsDefaultSettings, 'name'),
          },
        },
      }
    }

    case FETCH_SETTINGS_FOR_STANDS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case CREATE_VENUE_SETTINGS_NEW_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case CREATE_VENUE_SETTINGS_NEW_SUCCEEDED: {
      // when we create a new setting, we need to deactivate manually the old one because response returns only new settings, which means that the previous entry of created setting has old value in store
      const responseNames = payload?.map(({ name }) => name) ?? []

      const existedSettingsFilteredByResponseNames = Object.values(
        state.venueSettings.settings.byId
      ).filter(({ name }) => responseNames.includes(name))

      const updatedExistedSettingsFilteredByResponseNames =
        existedSettingsFilteredByResponseNames.map(
          (existedSetting) => {
            if (existedSetting.deactivatedAt === null) {
              return {
                ...existedSetting,
                deactivatedAt: new Date().toISOString(),
              }
            }
            return existedSetting
          }
        )

      return {
        ...state,
        isLoading: false,
        venueSettings: {
          ...state.venueSettings,
          settings: {
            ...state.venueSettings.settings,
            byId: {
              ...state.venueSettings.settings.byId,
              ...keyBy(
                updatedExistedSettingsFilteredByResponseNames,
                'uuid'
              ),
              ...keyBy(payload, 'uuid'),
            },
          },
        },
      }
    }

    case CREATE_VENUE_SETTINGS_NEW_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case FETCH_VENUE_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_VENUE_SETTINGS_SUCCEEDED: {
      const settings = payload.filter(
        (setting) =>
          setting.standId === null && setting.deactivatedAt === null
      )

      return {
        ...state,
        isLoading: false,
        byName: keyBy(settings, 'name'),
      }
    }

    case FETCH_VENUE_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case CREATE_VENUE_SETTINGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case CREATE_VENUE_SETTINGS_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        byName: {
          ...state.byName,
          ...keyBy(payload, 'name'),
        },
      }
    }

    case CREATE_VENUE_SETTINGS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    default:
      return state
  }
}

export default state
